import * as React from "react";
import { singleton } from "logic/singleton";
const PreviewLayoutContext = React.createContext(void 0);
export default singleton("contexts.PreviewLayoutContext", () => PreviewLayoutContext);
